import { render, staticRenderFns } from "./payroll-detail.vue?vue&type=template&id=f817fdf8&"
import script from "./payroll-detail.vue?vue&type=script&lang=js&"
export * from "./payroll-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports